module.exports = __webpack_public_path__ + "static/media/img_10.642e63c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_10.jpg
// module id = 528
// module chunks = 0